//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client';
import { getAxios, getBaseUrl } from './helpers';

export function getSurveys(surveyIds?: number[] | null | undefined, studyIds?: number[] | null | undefined, canBeTriggeredByDoctor?: boolean | null | undefined, canBeTriggeredByPatient?: boolean | null | undefined, canBeFilledByDoctor?: boolean | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.SurveyDto[]> {
    let url_ = getBaseUrl() + "/api/survey/surveys?";
    if (surveyIds !== undefined && surveyIds !== null)
        surveyIds && surveyIds.forEach(item => { url_ += "SurveyIds=" + encodeURIComponent("" + item) + "&"; });
    if (studyIds !== undefined && studyIds !== null)
        studyIds && studyIds.forEach(item => { url_ += "StudyIds=" + encodeURIComponent("" + item) + "&"; });
    if (canBeTriggeredByDoctor !== undefined && canBeTriggeredByDoctor !== null)
        url_ += "CanBeTriggeredByDoctor=" + encodeURIComponent("" + canBeTriggeredByDoctor) + "&";
    if (canBeTriggeredByPatient !== undefined && canBeTriggeredByPatient !== null)
        url_ += "CanBeTriggeredByPatient=" + encodeURIComponent("" + canBeTriggeredByPatient) + "&";
    if (canBeFilledByDoctor !== undefined && canBeFilledByDoctor !== null)
        url_ += "CanBeFilledByDoctor=" + encodeURIComponent("" + canBeFilledByDoctor) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetSurveys,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetSurveys(_response);
    });
}

function processGetSurveys(response: AxiosResponse): Promise<Types.SurveyDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.SurveyDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.SurveyDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SurveyDto[]>(null as any);
}

/**
 * Returns list of created surveys for given study and user.
 * @param patientId (optional) Id of the patient for requested survey statistic
 */
export function getLastSurveysStatistics(patientId?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<{ [key: string]: Types.SurveyStatisticsDto; }> {
    let url_ = getBaseUrl() + "/api/survey/lastSurveysStatistics?";
    if (patientId === null)
        throw new Error("The parameter 'patientId' cannot be null.");
    else if (patientId !== undefined)
        url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetLastSurveysStatistics,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetLastSurveysStatistics(_response);
    });
}

function processGetLastSurveysStatistics(response: AxiosResponse): Promise<{ [key: string]: Types.SurveyStatisticsDto; }> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (resultData200) {
            result200 = {} as any;
            for (let key in resultData200) {
                if (resultData200.hasOwnProperty(key))
                    (<any>result200)![key] = resultData200[key] ? Types.SurveyStatisticsDto.fromJS(resultData200[key]) : new Types.SurveyStatisticsDto();
            }
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<{ [key: string]: Types.SurveyStatisticsDto; }>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<{ [key: string]: Types.SurveyStatisticsDto; }>(null as any);
}

/**
 * @param patientId (optional) Id of the patient for requested answers
 * @param surveyType (optional) Type of the survey
 * @return Answers statistic for surveys for the whole study of patient
 */
export function getAnswersStatistic(patientId?: string | undefined, surveyType?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.AnswersStatisticsDto> {
    let url_ = getBaseUrl() + "/api/survey/answers/statistic?";
    if (patientId === null)
        throw new Error("The parameter 'patientId' cannot be null.");
    else if (patientId !== undefined)
        url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
    if (surveyType === null)
        throw new Error("The parameter 'surveyType' cannot be null.");
    else if (surveyType !== undefined)
        url_ += "surveyType=" + encodeURIComponent("" + surveyType) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetAnswersStatistic,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetAnswersStatistic(_response);
    });
}

function processGetAnswersStatistic(response: AxiosResponse): Promise<Types.AnswersStatisticsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.AnswersStatisticsDto.fromJS(resultData200);
        return Promise.resolve<Types.AnswersStatisticsDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.AnswersStatisticsDto>(null as any);
}

/**
 * @param answerId ID of the requested answer
 * @param patientId (optional) Id of the patient for requested answer
 * @return Answer statistic
 */
export function getAnswerStatistic(answerId: number, patientId?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.AnswersStatisticsDto> {
    let url_ = getBaseUrl() + "/api/survey/answer/{answerId}/statistic?";
    if (answerId === undefined || answerId === null)
      throw new Error("The parameter 'answerId' must be defined.");
    url_ = url_.replace("{answerId}", encodeURIComponent("" + answerId));
    if (patientId === null)
        throw new Error("The parameter 'patientId' cannot be null.");
    else if (patientId !== undefined)
        url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetAnswerStatistic,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetAnswerStatistic(_response);
    });
}

function processGetAnswerStatistic(response: AxiosResponse): Promise<Types.AnswersStatisticsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.AnswersStatisticsDto.fromJS(resultData200);
        return Promise.resolve<Types.AnswersStatisticsDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.AnswersStatisticsDto>(null as any);
}

/**
 * @param patientIds (optional) 
 * @param surveyIds (optional) 
 * @param questionnaireIds (optional) 
 * @param answeredBy (optional) Ids of the users who answered questionnaires
 * @param surveyTypes (optional) 
 * @param createdAfter (optional) 
 * @param createdBefore (optional) 
 * @param answerIds (optional) 
 */
export function getAnswers(patientIds?: string[] | null | undefined, surveyIds?: number[] | null | undefined, questionnaireIds?: number[] | null | undefined, answeredBy?: string[] | null | undefined, surveyTypes?: string[] | null | undefined, createdAfter?: Date | null | undefined, createdBefore?: Date | null | undefined, answerIds?: number[] | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.AnswerDto[]> {
    let url_ = getBaseUrl() + "/api/survey/answers?";
    if (patientIds !== undefined && patientIds !== null)
        patientIds && patientIds.forEach(item => { url_ += "PatientIds=" + encodeURIComponent("" + item) + "&"; });
    if (surveyIds !== undefined && surveyIds !== null)
        surveyIds && surveyIds.forEach(item => { url_ += "SurveyIds=" + encodeURIComponent("" + item) + "&"; });
    if (questionnaireIds !== undefined && questionnaireIds !== null)
        questionnaireIds && questionnaireIds.forEach(item => { url_ += "QuestionnaireIds=" + encodeURIComponent("" + item) + "&"; });
    if (answeredBy !== undefined && answeredBy !== null)
        answeredBy && answeredBy.forEach(item => { url_ += "AnsweredBy=" + encodeURIComponent("" + item) + "&"; });
    if (surveyTypes !== undefined && surveyTypes !== null)
        surveyTypes && surveyTypes.forEach(item => { url_ += "SurveyTypes=" + encodeURIComponent("" + item) + "&"; });
    if (createdAfter !== undefined && createdAfter !== null)
        url_ += "CreatedAfter=" + encodeURIComponent(createdAfter ? "" + createdAfter.toISOString() : "") + "&";
    if (createdBefore !== undefined && createdBefore !== null)
        url_ += "CreatedBefore=" + encodeURIComponent(createdBefore ? "" + createdBefore.toISOString() : "") + "&";
    if (answerIds !== undefined && answerIds !== null)
        answerIds && answerIds.forEach(item => { url_ += "AnswerIds=" + encodeURIComponent("" + item) + "&"; });
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetAnswers,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetAnswers(_response);
    });
}

function processGetAnswers(response: AxiosResponse): Promise<Types.AnswerDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.AnswerDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.AnswerDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.AnswerDto[]>(null as any);
}

/**
 * Saves answer for given survey and user if it is possible (if it has NOT expired yet).
 * @param dto Answer DTO.
 * @param awaitScoreCalculation (optional) The flag indicates scoring should be awaited or not
 * @return Id of saved/created/updated answer entity.
 */
export function saveAnswer(dto: Types.AnswerResultDto, awaitScoreCalculation?: boolean | undefined, config?: AxiosRequestConfig | undefined): Promise<number> {
    let url_ = getBaseUrl() + "/api/survey/answer?";
    if (awaitScoreCalculation === null)
        throw new Error("The parameter 'awaitScoreCalculation' cannot be null.");
    else if (awaitScoreCalculation !== undefined)
        url_ += "awaitScoreCalculation=" + encodeURIComponent("" + awaitScoreCalculation) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigSaveAnswer,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSaveAnswer(_response);
    });
}

function processSaveAnswer(response: AxiosResponse): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
        return Promise.resolve<number>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<number>(null as any);
}

/**
 * Trigger recalculation survey score
 * @param answerId (optional) 
 */
export function recalculateScore(answerId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<number> {
    let url_ = getBaseUrl() + "/api/survey/recalculateScore?";
    if (answerId === null)
        throw new Error("The parameter 'answerId' cannot be null.");
    else if (answerId !== undefined)
        url_ += "answerId=" + encodeURIComponent("" + answerId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRecalculateScore,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRecalculateScore(_response);
    });
}

function processRecalculateScore(response: AxiosResponse): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
        return Promise.resolve<number>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<number>(null as any);
}

/**
 * Creates and returns survey for given study.
 * @param dto Params of created object.
 */
export function createSurvey(dto: Types.CreateSurveyDto, config?: AxiosRequestConfig | undefined): Promise<Types.SurveyDto> {
    let url_ = getBaseUrl() + "/api/survey";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateSurvey,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateSurvey(_response);
    });
}

function processCreateSurvey(response: AxiosResponse): Promise<Types.SurveyDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.SurveyDto.fromJS(resultData200);
        return Promise.resolve<Types.SurveyDto>(result200);

    } else if (status === 201) {
        const _responseText = response.data;
        let result201: any = null;
        let resultData201  = _responseText;
        result201 = Types.SurveyDto.fromJS(resultData201);
        return Promise.resolve<Types.SurveyDto>(result201);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SurveyDto>(null as any);
}

/**
 * Create a rule that contains the schedule of the survey and its belonging to a group
 * @param dto Params of created object.
 */
export function createSurveyRule(dto: Types.CreateSurveyRuleDto, config?: AxiosRequestConfig | undefined): Promise<Types.SurveyRuleDto> {
    let url_ = getBaseUrl() + "/api/survey/create/rule";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateSurveyRule,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateSurveyRule(_response);
    });
}

function processCreateSurveyRule(response: AxiosResponse): Promise<Types.SurveyRuleDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.SurveyRuleDto.fromJS(resultData200);
        return Promise.resolve<Types.SurveyRuleDto>(result200);

    } else if (status === 201) {
        const _responseText = response.data;
        let result201: any = null;
        let resultData201  = _responseText;
        result201 = Types.SurveyRuleDto.fromJS(resultData201);
        return Promise.resolve<Types.SurveyRuleDto>(result201);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SurveyRuleDto>(null as any);
}

export function getQuestionnaires(patientId?: string | null | undefined, surveyIds?: number[] | null | undefined, triggeredByCurrentUser?: boolean | null | undefined, triggeredByDoctor?: boolean | null | undefined, triggeredByPatient?: boolean | null | undefined, ended?: boolean | null | undefined, active?: boolean | null | undefined, completed?: boolean | null | undefined, canBeFilledByDoctor?: boolean | null | undefined, forDisplayToPatient?: boolean | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.QuestionnaireDto[]> {
    let url_ = getBaseUrl() + "/api/survey/questionnaires?";
    if (patientId !== undefined && patientId !== null)
        url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
    if (surveyIds !== undefined && surveyIds !== null)
        surveyIds && surveyIds.forEach(item => { url_ += "SurveyIds=" + encodeURIComponent("" + item) + "&"; });
    if (triggeredByCurrentUser !== undefined && triggeredByCurrentUser !== null)
        url_ += "TriggeredByCurrentUser=" + encodeURIComponent("" + triggeredByCurrentUser) + "&";
    if (triggeredByDoctor !== undefined && triggeredByDoctor !== null)
        url_ += "TriggeredByDoctor=" + encodeURIComponent("" + triggeredByDoctor) + "&";
    if (triggeredByPatient !== undefined && triggeredByPatient !== null)
        url_ += "TriggeredByPatient=" + encodeURIComponent("" + triggeredByPatient) + "&";
    if (ended !== undefined && ended !== null)
        url_ += "Ended=" + encodeURIComponent("" + ended) + "&";
    if (active !== undefined && active !== null)
        url_ += "Active=" + encodeURIComponent("" + active) + "&";
    if (completed !== undefined && completed !== null)
        url_ += "Completed=" + encodeURIComponent("" + completed) + "&";
    if (canBeFilledByDoctor !== undefined && canBeFilledByDoctor !== null)
        url_ += "CanBeFilledByDoctor=" + encodeURIComponent("" + canBeFilledByDoctor) + "&";
    if (forDisplayToPatient !== undefined && forDisplayToPatient !== null)
        url_ += "ForDisplayToPatient=" + encodeURIComponent("" + forDisplayToPatient) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetQuestionnaires,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetQuestionnaires(_response);
    });
}

function processGetQuestionnaires(response: AxiosResponse): Promise<Types.QuestionnaireDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.QuestionnaireDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.QuestionnaireDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.QuestionnaireDto[]>(null as any);
}

/**
 * Create new questionnaire
 * @param patientId Patient ID
 * @param surveyId Survey ID
 * @param startDate Questionnaire start date
 * @param endDate Questionnaire end date
 */
export function createQuestionnaire(patientId: string, surveyId: number, startDate: Date, endDate: Date, config?: AxiosRequestConfig | undefined): Promise<Types.QuestionnaireDto> {
    let url_ = getBaseUrl() + "/api/survey/questionnaires?";
      if (patientId === undefined || patientId === null)
        throw new Error("The parameter 'patientId' must be defined and cannot be null.");
      else
        url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
      if (surveyId === undefined || surveyId === null)
        throw new Error("The parameter 'surveyId' must be defined and cannot be null.");
      else
        url_ += "surveyId=" + encodeURIComponent("" + surveyId) + "&";
      if (startDate === undefined || startDate === null)
        throw new Error("The parameter 'startDate' must be defined and cannot be null.");
      else
        url_ += "startDate=" + encodeURIComponent(startDate ? "" + Types.formatDate(startDate) : "") + "&";
      if (endDate === undefined || endDate === null)
        throw new Error("The parameter 'endDate' must be defined and cannot be null.");
      else
        url_ += "endDate=" + encodeURIComponent(endDate ? "" + Types.formatDate(endDate) : "") + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateQuestionnaire,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateQuestionnaire(_response);
    });
}

function processCreateQuestionnaire(response: AxiosResponse): Promise<Types.QuestionnaireDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.QuestionnaireDto.fromJS(resultData200);
        return Promise.resolve<Types.QuestionnaireDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.QuestionnaireDto>(null as any);
}

/**
 * @param patientId (optional) An id of a Patient that we get the prediction for
 * @param surveyIds (optional) Ids of Surveys that the prediction must be filtered by
 */
export function getPredictedQuestionnaires(patientId?: string | undefined, surveyIds?: number[] | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PredictedQuestionnaireDto[]> {
    let url_ = getBaseUrl() + "/api/survey/questionnaires/predicted?";
    if (patientId === null)
        throw new Error("The parameter 'patientId' cannot be null.");
    else if (patientId !== undefined)
        url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
    if (surveyIds !== undefined && surveyIds !== null)
        surveyIds && surveyIds.forEach(item => { url_ += "SurveyIds=" + encodeURIComponent("" + item) + "&"; });
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetPredictedQuestionnaires,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetPredictedQuestionnaires(_response);
    });
}

function processGetPredictedQuestionnaires(response: AxiosResponse): Promise<Types.PredictedQuestionnaireDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.PredictedQuestionnaireDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.PredictedQuestionnaireDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PredictedQuestionnaireDto[]>(null as any);
}

export function deleteQuestionnaire(questionnaireId: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/survey/questionnaires/{questionnaireId}";
    if (questionnaireId === undefined || questionnaireId === null)
      throw new Error("The parameter 'questionnaireId' must be defined.");
    url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigDeleteQuestionnaire,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDeleteQuestionnaire(_response);
    });
}

function processDeleteQuestionnaire(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Get survey results (answers) for the patient
 * @param surveyType (optional) 
 * @deprecated
 */
export function getSurveyRecordsForPatient(surveyType?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.AnswerDto[]> {
    let url_ = getBaseUrl() + "/api/survey/records?";
    if (surveyType === null)
        throw new Error("The parameter 'surveyType' cannot be null.");
    else if (surveyType !== undefined)
        url_ += "surveyType=" + encodeURIComponent("" + surveyType) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetSurveyRecordsForPatient,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetSurveyRecordsForPatient(_response);
    });
}

function processGetSurveyRecordsForPatient(response: AxiosResponse): Promise<Types.AnswerDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.AnswerDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.AnswerDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.AnswerDto[]>(null as any);
}

/**
 * Returns list of available SurveyRules for study. Could be filtered by group of study.
 * @param studyId Requested Study
 * @param groupId (optional) Optional filter by group.
 */
export function getSurveyRulesByStudy(studyId: number, groupId?: number | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.SurveyRuleDto[]> {
    let url_ = getBaseUrl() + "/api/survey/rules/{studyId}?";
    if (studyId === undefined || studyId === null)
      throw new Error("The parameter 'studyId' must be defined.");
    url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
    if (groupId !== undefined && groupId !== null)
        url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetSurveyRulesByStudy,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetSurveyRulesByStudy(_response);
    });
}

function processGetSurveyRulesByStudy(response: AxiosResponse): Promise<Types.SurveyRuleDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.SurveyRuleDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.SurveyRuleDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SurveyRuleDto[]>(null as any);
}
let _requestConfigGetSurveys: Partial<AxiosRequestConfig> | null;
export function getGetSurveysRequestConfig() {
  return _requestConfigGetSurveys;
}
export function setGetSurveysRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetSurveys = value;
}
export function patchGetSurveysRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetSurveys = patch(_requestConfigGetSurveys ?? {});
}

let _requestConfigGetLastSurveysStatistics: Partial<AxiosRequestConfig> | null;
export function getGetLastSurveysStatisticsRequestConfig() {
  return _requestConfigGetLastSurveysStatistics;
}
export function setGetLastSurveysStatisticsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetLastSurveysStatistics = value;
}
export function patchGetLastSurveysStatisticsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetLastSurveysStatistics = patch(_requestConfigGetLastSurveysStatistics ?? {});
}

let _requestConfigGetAnswersStatistic: Partial<AxiosRequestConfig> | null;
export function getGetAnswersStatisticRequestConfig() {
  return _requestConfigGetAnswersStatistic;
}
export function setGetAnswersStatisticRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetAnswersStatistic = value;
}
export function patchGetAnswersStatisticRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetAnswersStatistic = patch(_requestConfigGetAnswersStatistic ?? {});
}

let _requestConfigGetAnswerStatistic: Partial<AxiosRequestConfig> | null;
export function getGetAnswerStatisticRequestConfig() {
  return _requestConfigGetAnswerStatistic;
}
export function setGetAnswerStatisticRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetAnswerStatistic = value;
}
export function patchGetAnswerStatisticRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetAnswerStatistic = patch(_requestConfigGetAnswerStatistic ?? {});
}

let _requestConfigGetAnswers: Partial<AxiosRequestConfig> | null;
export function getGetAnswersRequestConfig() {
  return _requestConfigGetAnswers;
}
export function setGetAnswersRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetAnswers = value;
}
export function patchGetAnswersRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetAnswers = patch(_requestConfigGetAnswers ?? {});
}

let _requestConfigSaveAnswer: Partial<AxiosRequestConfig> | null;
export function getSaveAnswerRequestConfig() {
  return _requestConfigSaveAnswer;
}
export function setSaveAnswerRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSaveAnswer = value;
}
export function patchSaveAnswerRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSaveAnswer = patch(_requestConfigSaveAnswer ?? {});
}

let _requestConfigRecalculateScore: Partial<AxiosRequestConfig> | null;
export function getRecalculateScoreRequestConfig() {
  return _requestConfigRecalculateScore;
}
export function setRecalculateScoreRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRecalculateScore = value;
}
export function patchRecalculateScoreRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRecalculateScore = patch(_requestConfigRecalculateScore ?? {});
}

let _requestConfigCreateSurvey: Partial<AxiosRequestConfig> | null;
export function getCreateSurveyRequestConfig() {
  return _requestConfigCreateSurvey;
}
export function setCreateSurveyRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateSurvey = value;
}
export function patchCreateSurveyRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateSurvey = patch(_requestConfigCreateSurvey ?? {});
}

let _requestConfigCreateSurveyRule: Partial<AxiosRequestConfig> | null;
export function getCreateSurveyRuleRequestConfig() {
  return _requestConfigCreateSurveyRule;
}
export function setCreateSurveyRuleRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateSurveyRule = value;
}
export function patchCreateSurveyRuleRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateSurveyRule = patch(_requestConfigCreateSurveyRule ?? {});
}

let _requestConfigGetQuestionnaires: Partial<AxiosRequestConfig> | null;
export function getGetQuestionnairesRequestConfig() {
  return _requestConfigGetQuestionnaires;
}
export function setGetQuestionnairesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetQuestionnaires = value;
}
export function patchGetQuestionnairesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetQuestionnaires = patch(_requestConfigGetQuestionnaires ?? {});
}

let _requestConfigCreateQuestionnaire: Partial<AxiosRequestConfig> | null;
export function getCreateQuestionnaireRequestConfig() {
  return _requestConfigCreateQuestionnaire;
}
export function setCreateQuestionnaireRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateQuestionnaire = value;
}
export function patchCreateQuestionnaireRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateQuestionnaire = patch(_requestConfigCreateQuestionnaire ?? {});
}

let _requestConfigGetPredictedQuestionnaires: Partial<AxiosRequestConfig> | null;
export function getGetPredictedQuestionnairesRequestConfig() {
  return _requestConfigGetPredictedQuestionnaires;
}
export function setGetPredictedQuestionnairesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetPredictedQuestionnaires = value;
}
export function patchGetPredictedQuestionnairesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetPredictedQuestionnaires = patch(_requestConfigGetPredictedQuestionnaires ?? {});
}

let _requestConfigDeleteQuestionnaire: Partial<AxiosRequestConfig> | null;
export function getDeleteQuestionnaireRequestConfig() {
  return _requestConfigDeleteQuestionnaire;
}
export function setDeleteQuestionnaireRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDeleteQuestionnaire = value;
}
export function patchDeleteQuestionnaireRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDeleteQuestionnaire = patch(_requestConfigDeleteQuestionnaire ?? {});
}

let _requestConfigGetSurveyRecordsForPatient: Partial<AxiosRequestConfig> | null;
export function getGetSurveyRecordsForPatientRequestConfig() {
  return _requestConfigGetSurveyRecordsForPatient;
}
export function setGetSurveyRecordsForPatientRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetSurveyRecordsForPatient = value;
}
export function patchGetSurveyRecordsForPatientRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetSurveyRecordsForPatient = patch(_requestConfigGetSurveyRecordsForPatient ?? {});
}

let _requestConfigGetSurveyRulesByStudy: Partial<AxiosRequestConfig> | null;
export function getGetSurveyRulesByStudyRequestConfig() {
  return _requestConfigGetSurveyRulesByStudy;
}
export function setGetSurveyRulesByStudyRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetSurveyRulesByStudy = value;
}
export function patchGetSurveyRulesByStudyRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetSurveyRulesByStudy = patch(_requestConfigGetSurveyRulesByStudy ?? {});
}